import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { AppScope, currentAppScope } from '../scope/app-scope';

function readRequiredScopes(route: ActivatedRouteSnapshot): AppScope[] | null {
  const raw = route.data?.['requiredScopes'];
  if (!Array.isArray(raw)) {
    return null;
  }

  const scopes = raw
    .filter((item): item is string => typeof item === 'string')
    .map(item => item.trim().toLowerCase())
    .filter((item): item is AppScope => item === 'admin' || item === 'organization');

  return scopes.length > 0 ? scopes : null;
}

export const scopeGuard: CanActivateChildFn = (childRoute) => {
  const router = inject(Router);
  const requiredScopes = readRequiredScopes(childRoute);
  const scope = currentAppScope();

  if (!requiredScopes) {
    // Fail-safe for unified portal: organization scope only accesses routes
    // explicitly annotated with requiredScopes.
    return scope === 'admin'
      ? true
      : router.parseUrl('/dashboard');
  }

  return requiredScopes.includes(scope)
    ? true
    : router.parseUrl('/dashboard');
};

